import React from 'react';

import Container from './Container.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function Separator(props) {
    const config = props.config || {};
    let blockProps = {};
    const blockConfig = config.config;
    if (blockConfig && blockConfig.Block) {
        blockProps = blockConfig.Block;
    }
    let borderWidth = '1px';
    if (blockProps && blockProps.borderWidth && blockProps.borderWidth.value && blockProps.borderWidth.value.length > 0) {
        borderWidth = `${blockProps.borderWidth.value}${blockProps.borderWidth.unit}`;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td style={{ borderBottom: `${borderWidth} solid ${blockProps.color}` }}>
                    {props.builder && Utilities.Builder.dragOutline()}
                </td>
            </tr>
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    _TypeConfig.options.firstPageOnly(),
                    {
                        display: 'Line Color',
                        group,
                        name: 'color',
                        type: 'color-left',
                        value: '#e9e9e9'
                    },
                    {
                        display: 'Line Width',
                        fullWidth: true,
                        group,
                        name: 'borderWidth',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    }
                ]
            };
        },
        style: () => {
            const group = 'block';
            return {
                group,
                options: [
                    {
                        disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                        display: 'Padding',
                        group,
                        name: 'paddingMargin',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'paddingMargin',
                        value: { 
                            paddingBottom: { unit: 'px', value: '20' }, 
                            paddingTop: { unit: 'px', value: '20' }
                        }
                    }
                ]
            }
        }
    }
};

export {
    Separator as Component,
    TypeConfig
};